<script lang="ts" setup>
import { UserLabel } from '@/models/label.model';
import { useEvents, Event } from '@/services/events.composable';
import { Actions, Mutations, ShiftCMSState } from '@/store';
import { LabelsActions, LabelsState } from '@/stores/labels.store';
import { NEW_ID } from '@/util/constants';
import { computed, onMounted, PropType, ref, defineProps } from 'vue';
import { useStore } from 'vuex';

const store = useStore<ShiftCMSState & { ls: LabelsState }>();
const events = useEvents();

const props = defineProps({
  data: {
    type: Object as PropType<UserLabel>,
  },
});

const valid = ref<boolean>(false);

const label = ref<UserLabel>({
  id: NEW_ID,
  value: '',
});

const action = computed<string>(() =>
  label.value.id === NEW_ID ? 'Add' : 'Save',
);

const saveCategory = async () => {
  let success: boolean = false;
  if (valid.value) {
    if (label.value.id === NEW_ID) {
      success = await store.dispatch(LabelsActions.AddLabel, label.value);
    } else {
      success = await store.dispatch(LabelsActions.UpdateLabel, label.value);
    }
  }
  if (success) {
    events.emit(Event.Saved, true);
    store.dispatch(Actions.ShowNotification, {
      message: 'Saved label',
      type: 'success',
    });
    store.commit(Mutations.HideDrawer);
    store.dispatch(LabelsActions.GetLabels);
  } else {
    store.dispatch(Actions.ShowNotification, {
      message: 'Failed to save label',
      type: 'error',
    });
  }
};

onMounted(() => {
  if (props.data) {
    Object.assign(label.value, props.data);
  }
});

const removeLabel = async () => {
  if (
    label.value &&
    label.value.id !== NEW_ID &&
    confirm('Are you absolutely sure you want to delete this "Label"?')
  ) {
    store.dispatch(LabelsActions.DeleteLabel, label.value.id);

    store.commit(Mutations.HideDrawer);
  }
};
</script>
<template>
  <v-form v-model="valid" @submit.prevent="saveCategory">
    <v-container>
      <h2>{{ $t(action) }} a label</h2>
      <v-row>
        <v-col class="mx-auto">
          <v-text-field
            v-model="label.value"
            label="Value"
            required
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col col="2"></v-col>
        <v-col>
          <v-btn
            class="mt-2"
            type="button"
            color="warning"
            @click="removeLabel"
            block
            >Delete</v-btn
          >
        </v-col>
        <v-col>
          <v-btn class="mt-2" type="reset" block>Reset</v-btn>
        </v-col>
        <v-col>
          <v-btn class="mt-2" type="submit" color="success" block>{{
            action
          }}</v-btn>
        </v-col>
        <v-col col="2"></v-col>
      </v-row>
    </v-container>
  </v-form>
</template>
